import {
    buildTeamLogoOptions,
    getDefaultValue,
    getLogoUrl,
    getTeamLogoUrlByTeamId,
    getCountryFlagByCountryId
} from '@draftkings/sportsbook-common-utils';
import { TeamLogoOptions } from '@draftkings/sportsbook-common-contracts';
import { LogosMap } from '../../contracts';
import type * as ContractTypes from '@draftkings/dk-data-layer';

export const getTeamLogo = (
    participant: ContractTypes.Participant,
    logosTeam: LogosMap['Teams'] | undefined,
    staticS3Host: string,
    swooshBaseUrl: string,
    isSwooshTeamLogosEnabledForSportSlider: boolean
): string => {
    const isNationalTeam = participant?.isNationalTeam || false;

    if (isNationalTeam) {
        const options: TeamLogoOptions = buildTeamLogoOptions('sm', 'dark');

        return isSwooshTeamLogosEnabledForSportSlider
            ? getDefaultValue(
                  getCountryFlagByCountryId(swooshBaseUrl, participant.countryCode || '', options)?.toString(),
                  ''
              )
            : getDefaultValue(getLogoUrl(staticS3Host, logosTeam, participant.name), '');
    }

    const options: TeamLogoOptions = buildTeamLogoOptions('sm', 'dark', participant.venueRole);
    const teamId = participant.metadata?.rosettaTeamId || participant.id;

    return isSwooshTeamLogosEnabledForSportSlider
        ? getDefaultValue(getTeamLogoUrlByTeamId(swooshBaseUrl, teamId, options)?.toString(), '')
        : getDefaultValue(getLogoUrl(staticS3Host, logosTeam, participant.name), '');
};
